module.exports = __webpack_public_path__ + "static/media/insert-casette.bfbc083d.jpg";